import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useAuth } from '../../context/AuthContext'
import NotificationBell from '../../features/notifications/NotificationBell'
import ProfileDropdown from '../../features/profile/ProfileDropdown'
import OrderModal from '../../features/order-create/OrderModal'
import { useEmployeeActivity } from '../lib/useEmployeeActivity'

export default function Layout() {
    const { user, token } = useAuth()
    useEmployeeActivity(user, token)
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])
    const [editingOrder, setEditingOrder] = useState(null)

    return (
        <div style={{ minHeight: '100vh', background: '#F3F5F9' }}>
            {showModal && (
                <OrderModal
                    order={editingOrder}
                    token={token}
                    onClose={() => { setShowModal(false); setEditingOrder(null) }}
                    onSave={() => { setShowModal(false); setEditingOrder(null) }}
                />
            )}

            <div style={{ background: 'rgba(255,255,255,.94)', backdropFilter: 'saturate(1.4) blur(10px)', WebkitBackdropFilter: 'saturate(1.4) blur(10px)', borderBottom: '2px solid #0052FF', boxShadow: '0 6px 18px -14px rgba(16,24,40,.35)', padding: '10px 16px 11px', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <img src="/logo.png" alt="CoFresh" style={{ height: '14px', filter: 'invert(1)' }} />
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        {user?.role === 'master' && (
                            <button
                                onClick={() => { document.dispatchEvent(new CustomEvent('close-all-panels')); setEditingOrder(null); setShowModal(true) }}
                                style={{ fontSize: '13px', color: 'white', background: '#0052FF', border: 'none', borderRadius: '8px', padding: '6px 14px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                + Новая
                            </button>
                        )}
                        <NotificationBell />
                        {['ros','service_director'].includes(user?.role) && <button type="button" title="Сотрудники" aria-label="Сотрудники" aria-current={pathname === '/employees' || pathname.startsWith('/salons') ? 'page' : undefined}
                            onClick={() => { document.dispatchEvent(new CustomEvent('close-all-panels')); navigate(user.role === 'service_director' ? '/salons' : '/employees') }}
                            style={{ width: '32px', height: '32px', boxSizing: 'border-box', padding: 0, border: 0, boxShadow: 'inset 0 0 0 1.5px #C9D8FF', borderRadius: '50%', background: '#EEF3FF', color: '#0052FF', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                            <i className="ti ti-users" aria-hidden="true" style={{ fontSize: '16px' }} />
                        </button>}
                        <ProfileDropdown />
                    </div>
                </div>
            </div>

            <div style={{ paddingTop: '52px' }}>
                <Outlet />
            </div>
        </div>
    )
}
